import type { SxProps, Theme } from '@mui/material';

export const styles = {
    titleAndActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 1,
    } as SxProps<Theme>,
    quickFilterRow: {
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        mb: 2,
        flexWrap: 'wrap',
    } as SxProps<Theme>,
    quickFilterBtn: (selected: boolean, theme: Theme, index: number): SxProps<Theme> => ({
        p: 0.5,
        m: 0.5,
        ml: index === 0 ? 0 : 0.5,
        pl: index === 0 ? 0 : 0.5,
        fontSize: '16px',
        textTransform: 'none',
        color: selected ? theme.palette.blue[500] : theme.palette.grey[500],
        position: 'relative',
        borderRadius: 0,
        '&:hover': { backgroundColor: 'transparent' },
        '&::after': selected
            ? {
                content: '""',
                position: 'absolute',
                left: '10%',
                bottom: 0,
                width: '80%',
                borderBottom: `3px solid ${theme.palette.blue[500]}`,
            }
            : {},
    }),
    newJobButton: {
        '& .MuiButton-startIcon .MuiSvgIcon-root': { color: 'white' },
    } as SxProps<Theme>,
    contentContainer: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        boxShadow: theme.shadows[1],
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    }),
    subFilterRow: {
        display: 'flex',
        gap: 1,
        padding: 1,
    } as SxProps<Theme>,
    subFilterBtn: (selected: boolean, theme: Theme): SxProps<Theme> => ({
        py: 0.5,
        px: 3,
        m: 1,
        fontSize: '16px',
        textTransform: 'none',
        fontWeight: 400,
        color: selected ? theme.palette.white : theme.palette.black,
        backgroundColor: selected ? theme.palette.blue[800] : theme.palette.grey[50],
        '&:hover': {
            backgroundColor: selected ? theme.palette.blue[900] : theme.palette.grey[100],
        },
    }),
    filterRow: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        padding: 1,
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    } as SxProps<Theme>,
    filterLeft: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        flexWrap: 'wrap',
    } as SxProps<Theme>,
    filterRight: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        flexWrap: 'wrap',
    } as SxProps<Theme>,
    sortSelect: (theme: Theme): SxProps<Theme> => ({
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: '8px',
        height: '32px',
        fontSize: '12px',
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '& .MuiSelect-select': { display: 'flex', alignItems: 'center', py: 0.5 },
    }),
    clearAllBtn: (theme: Theme): SxProps<Theme> => ({
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: '8px',
        height: 32,
        width: 32,
        color: theme.palette.grey[700],
        backgroundColor: 'white',
        '& .MuiSvgIcon-root': {
            color: theme.palette.grey[700],
        },
        '&:hover': {
            backgroundColor: theme.palette.blue[40],
            borderColor: theme.palette.blue.main,
            '& .MuiSvgIcon-root': {
                color: theme.palette.blue.main,
            },
        },
        '&.Mui-disabled': {
            borderColor: theme.palette.grey[50],
            backgroundColor: theme.palette.grey[30],
            cursor: 'not-allowed',
            pointerEvents: 'auto',
            opacity: 0.5,
            '& .MuiSvgIcon-root': {
                color: theme.palette.grey[200],
            },
        },
    }),
    layoutRow: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    } as SxProps<Theme>,
    jobListPanel: (theme: Theme, hideOnMobile: boolean): SxProps<Theme> => ({
        flex: { xs: '1 1 auto', md: '0 0 360px' },
        width: { xs: '100%', md: 'auto' },
        height: '100%',
        overflow: 'auto',
        borderRight: { md: `1px solid ${theme.palette.grey[50]}` },
        display: hideOnMobile ? { xs: 'none', md: 'block' } : 'block',
    }),
    mobileBackBar: (theme: Theme): SxProps<Theme> => ({
        display: { xs: 'flex', md: 'none' },
        alignItems: 'center',
        gap: 0.5,
        py: 1,
        px: 0.5,
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        cursor: 'pointer',
        color: theme.palette.blue.main,
        fontSize: '14px',
        fontWeight: 500,
    }),
    endMessage: {
        textAlign: 'center',
        marginTop: '10px',
        padding: '8px',
        color: 'grey.500',
        fontSize: '12px',
    } as SxProps<Theme>,
    jobDetailsPanel: (hideOnMobile: boolean): SxProps<Theme> => ({
        flex: 1,
        height: '100%',
        overflow: 'auto',
        minWidth: 0,
        width: { xs: '100%', md: 'auto' },
        display: hideOnMobile ? { xs: 'none', md: 'flex' } : 'flex',
        flexDirection: 'column',
    }),
    emptyState: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: 'grey.500',
    } as SxProps<Theme>,
};
